export class IngestionPipelineMetricsRange {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startTs",
            "baseName": "startTs",
            "type": "number",
            "format": ""
        },
        {
            "name": "endTs",
            "baseName": "endTs",
            "type": "number",
            "format": ""
        },
        {
            "name": "stepSeconds",
            "baseName": "stepSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "seriesByName",
            "baseName": "seriesByName",
            "type": "{ [key: string]: MetricTimeseries; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineMetricsRange.attributeTypeMap;
    }
    constructor() {
    }
}
